import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import * as React from 'react';

import Button from '@/components/elements/Button/BaseButton';
import useClock from '@/hooks/date/useClock';

import OverDeadlineModalBase from '../index';
import { ButtonWrapper } from './style';

interface SingleraceOverDeadlineModalProps {
  orderDeadline: dayjs.Dayjs;
  isCanceled: boolean;
  onClosed: () => void;
}

const SingleraceOverDeadlineWatcher: React.FC<
  SingleraceOverDeadlineModalProps
> = ({ orderDeadline, isCanceled, onClosed }) => {
  const [isOpen, setIsOpen] = useState<boolean>(isCanceled);
  const clock = useClock();

  // 投票締め切られた時にモーダルを表示する
  useEffect(() => {
    if (orderDeadline.isBefore(clock)) {
      setIsOpen(true);
    }
  }, [orderDeadline.isBefore(clock)]);

  const handleClose = () => {
    onClosed();
    setIsOpen(false);
  };

  return (
    <OverDeadlineModalBase
      isOpen={isOpen}
      isCanceled={isCanceled}
      isSalesSuspended={false}
      handleClose={handleClose}
    >
      <ButtonWrapper>
        <Button
          size="m"
          bgColor="primary"
          fontWeight="bold"
          height="56px"
          radius="l"
          onClick={() => handleClose()}
        >
          OK
        </Button>
      </ButtonWrapper>
    </OverDeadlineModalBase>
  );
};

export default SingleraceOverDeadlineWatcher;
